import { render } from "./TiposRecargaList.vue?vue&type=template&id=6616c2ee&scoped=true"
import script from "./TiposRecargaList.vue?vue&type=script&lang=js"
export * from "./TiposRecargaList.vue?vue&type=script&lang=js"

import "./TiposRecargaList.vue?vue&type=style&index=0&id=6616c2ee&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6616c2ee"]])

export default __exports__